export default function loadImagesFromFilestore(payload, store) {
  return store.dispatch('filestore/getFileURLBulk', payload)
}
